import { styles, colors } from "../styles";

// Web-only chooser shown after the user clicks an "Export PDF" button.
// Native (Capacitor) skips this modal — the OS Share sheet plays the
// same role there. Pass a built jsPDF doc in via `pending`; the parent
// owns the print / save handlers.
export default function PdfActionModal({
  pending,
  title = "Export PDF",
  onPrint,
  onSave,
  onCancel,
}) {
  if (!pending) return null;

  return (
    <div
      onClick={onCancel}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "white",
          borderRadius: "10px",
          padding: "20px",
          width: "100%",
          maxWidth: "320px",
          boxShadow: "0 10px 32px rgba(0,0,0,0.3)",
        }}
      >
        <h3 style={{ margin: "0 0 14px", textAlign: "center" }}>{title}</h3>
        <button
          style={{
            ...styles.primaryButton,
            display: "block",
            width: "100%",
            margin: "8px 0",
            padding: "12px",
            fontSize: "14px",
          }}
          onClick={onPrint}
        >
          Print PDF
        </button>
        <button
          style={{
            ...styles.primaryButton,
            display: "block",
            width: "100%",
            margin: "8px 0",
            padding: "12px",
            fontSize: "14px",
          }}
          onClick={onSave}
        >
          Save PDF
        </button>
        <button
          style={{
            ...styles.button,
            display: "block",
            width: "100%",
            margin: "8px 0 0",
            padding: "10px",
            color: colors.textMuted,
          }}
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
